import { TextLink } from "components/actions/Links";
import Modal from "components/ui/modal/Modal";
import {
  BodyText,
  ContentBlocks,
  ModalSections,
  ModalTitle,
  Section,
} from "../LearnMoreModalContent";
import { CmsLearnMoreContent, TRUST_CENTRE_URL } from "./cmsLearnMoreContent";

type Props = {
  content: CmsLearnMoreContent;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/** What a cloud storage integration does and how to set it up, shown from the provider's card. */
export default function CMSLearnMoreModal({ content, open, onOpenChange }: Props): JSX.Element {
  return (
    <Modal open={open} onOpenChange={onOpenChange} width="560px" padding={24}>
      <ModalSections>
        <ModalTitle>{content.modalTitle}</ModalTitle>
        <Section>
          {content.intro.map((paragraph) => (
            <BodyText key={paragraph}>{paragraph}</BodyText>
          ))}
        </Section>
        <ContentBlocks blocks={content.contentBlocks} />
        <BodyText>
          For more on how we keep your content secure, visit our{" "}
          <TextLink to={TRUST_CENTRE_URL} targetType="external">
            Trust Centre
          </TextLink>
          .
        </BodyText>
      </ModalSections>
    </Modal>
  );
}
